import { useQuery } from "@apollo/client/react";
import { Grid } from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import DataGridGenerico from "../../../../components/dataGrid/DataGridGenerico";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { adaptBitacoraArray, GET_OPCIONES_ACCIONES, OBTENER_BITACORA } from "../../../../data/graphQL/queries/SoporteHC/consultas";
import { downloadExcel } from "../../../../utils/downloadExcel";
import { useGetBitacoraColumns } from "../../hooks/useGetBitacoraColumns";
import { useQueryHandler } from "../../hooks/useQueryHandler";
import { accionCambioPrecioId, accionOpcionTodos } from "../../utils/constants";

export default function BitacoraForm() {
    const inputFields = [
        {
            name: 'fechaDesde',
            type: 'date',
            displayName: 'Fecha desde',
            size: 2,
            required: true,
            placeholder: 'Ingrese Fecha desde'
        },
        {
            name: 'fechaHasta',
            type: 'date',
            displayName: 'Fecha hasta',
            size: 2,
            required: true,
            placeholder: 'Ingrese Fecha hasta'
        },
        {
            name: 'idAccion',
            type: 'select',
            displayName: 'Acción',
            size: 2,
            required: false,
            placeholder: 'Seleccione una acción'
        },
        {
            name: 'descripcion',
            type: 'string',
            displayName: 'Descripción',
            size: 12,
            required: false,
            placeholder: 'Ingrese Descripción'
        },
    ];

    const [result, setResult] = useState([]);
    const [accionesOptions, setAccionesOptions] = useState([]);
    const [submitted, setSubmitted] = useState(false);

    const { data: dataAcciones } = useQuery(GET_OPCIONES_ACCIONES);

    useEffect(() => {
        if (!dataAcciones) return;
        const parsedAcciones = dataAcciones.accionGestion.map(accion => ({
            id: accion.idAccion,
            displayName: `${accion.paginaSolapa} - ${accion.accion}`
        }));
        parsedAcciones.unshift(accionOpcionTodos);
        setAccionesOptions(parsedAcciones);
    }, [dataAcciones]);

    const { values, handleChange, handleSubmit, loading } =
        useQueryHandler({
            initialValues: {
                fechaDesde: moment().subtract(1, 'day'),
                fechaHasta: moment().add(1, 'day'),
                idAccion: 0,
                descripcion: '',
            },
            query: OBTENER_BITACORA,
            onSuccess: (data) => {
                setResult(adaptBitacoraArray(data.bitacora));
                setSubmitted(true);
            },
            handleChangeCallback: () => {
                setResult([]);
                setSubmitted(false);
            },
            inputFields
        });

    const mostrarColumnasPrecio = useMemo(() => values.idAccion === accionOpcionTodos.id || values.idAccion === accionCambioPrecioId, [values.idAccion]);

    const { dataGridColumns, excelColumns } = useGetBitacoraColumns(mostrarColumnasPrecio);

    const descargarExcel = (data) => {
        if (!excelColumns?.length || !data?.bitacora?.length) return;
        const body = adaptBitacoraArray(data.bitacora);

        downloadExcel({
            fileName: `Soporte HC - ${accionesOptions?.find(x => x.id === values.idAccion)?.displayName}`,
            sheet: "Bitacora",
            tablePayload: {
                header: excelColumns,
                body
            }
        });
    }

    return (
        <form onSubmit={(e) => handleSubmit(e)}>
            <Grid container spacing={2}>
                {inputFields.map(({ size, ...input }) => {
                    const inputWithOptions = input.name === 'idAccion'
                        ? { ...input, options: accionesOptions }
                        : input;

                    return (
                        <Grid key={input.name} size={{ xs: 12, sm: (size || 12) }} className="form-field-wrapper">
                            <RenderInputByTypeMobile
                                input={inputWithOptions}
                                value={values[input.name]}
                                handleChange={handleChange}
                            />
                        </Grid>
                    );
                })}
                <Grid size={12} display='flex' alignItems='center'>
                    <CustomButton
                        sx={{ mr: 2 }}
                        variant='outlined'
                        isLoading={loading}
                        onClick={handleSubmit}
                    >
                        Aceptar
                    </CustomButton>
                    <CustomButton
                        variant='contained'
                        isLoading={loading}
                        onClick={e => handleSubmit(e, descargarExcel)}
                    >
                        Descargar
                    </CustomButton>
                </Grid>
                {submitted && <Grid size={12}>
                    <DataGridGenerico
                        rows={result}
                        columns={dataGridColumns}
                    />
                </Grid>}
            </Grid>
            <button type="submit" hidden />
        </form>
    )
}
